// require('./utils/tracking.js');
require('./scripts/main.js');
// require('expose-loader?React!react');
// require('expose-loader?ReactDOM!react-dom');
require('expose-loader?Components!./components/index.js');
